import * as React from 'react';
import type { SVGProps } from 'react';
const SvgManageAccount = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 70 64"
    {...props}
  >
    <path
      stroke="#4B7EFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M48.333 52 55 58.667l13.333-13.334M35 42H21.667c-6.213 0-9.32 0-11.77 1.015a13.33 13.33 0 0 0-7.215 7.216C1.667 52.68 1.667 55.787 1.667 62m45-59.03C51.553 4.946 55 9.737 55 15.332c0 5.596-3.447 10.387-8.333 12.365M40 15.333c0 7.364-5.97 13.334-13.333 13.334s-13.334-5.97-13.334-13.334S19.303 2 26.667 2 40 7.97 40 15.333"
    />
  </svg>
);
export default SvgManageAccount;
